import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './App';
import { routes } from './routes';
import './styles.css';
const path = window.location.pathname;
const normalized = path === '/' ? '/' : `${path.replace(/\/+$/, '')}/`;
const meta = routes.find((r) => r.path === normalized);
if (meta) {
  document.title = meta.title;
  document.querySelector('meta[name="description"]')?.setAttribute('content', meta.description);
}
const root = document.getElementById('root')!;
const app = <App path={path} />;
if (root.hasChildNodes()) hydrateRoot(root, app);
else createRoot(root).render(app);
